import { Component, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ShortDatePipe } from '../../shared/pipes/short-date.pipe';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerDetailModalComponent, CustomerDetailModalContext } from '../detail/customer-detail-modal/customer-details-modal.component';
import { CustomerIdentificationType } from '../models/enums/customer-identification-type.enum';
import { CustomerRequestStatusType } from '../models/enums/customer-request-status-type.enum';
import { CustomerSearchService } from '../shared/customer-search.service';
import { CustomerRequestContext, CustomerRequestModalComponent } from './customer-request-modal.component';
import { CustomerRequestService } from './customer-request-queue.service';

@Component({
    selector: 'customer-request-queue-component',
    templateUrl: './customer-request-queue.html'
})
export class CustomerRequestQueueComponent {
    @ViewChild('dataTable') dataTable: Table;
    showRegistrationRequestQueue = false;
    customerRequestQueueData: any = { queueItems: [] };

    constructor(
        public modalService: MvdModalService,
        public customerRequestService: CustomerRequestService,
        public customerSearchService: CustomerSearchService,
        public shortDatePipe: ShortDatePipe
    ) {}

    ngOnInit() {
        this.getCustomerRequestQueueData();
    }

    public changeAssignedUser = (customerRequestId, userLoginId): void => {
        this.customerRequestService.assignCustomerRequestToUser(customerRequestId, userLoginId).subscribe(
            data => {
                this.getCustomerRequestQueueData();
            },
            e => {
                this.getCustomerRequestQueueData();
            }
        );
    };

    public changeStatusType = (customerRequestId, statusTypeId): void => {
        this.customerRequestService.changeCustomerRequestStatus(customerRequestId, statusTypeId).subscribe(
            data => {
                this.getCustomerRequestQueueData();
            },
            e => {
                this.getCustomerRequestQueueData();
            }
        );
    };

    private getCustomerRequestQueueData = (): void => {
        this.customerRequestService.getCustomerRequestQueueData().subscribe(
            data => {
                this.showRegistrationRequestQueue = data.result.userHasAccessToQueue;
                for (var i = 0; i < data.result.queueItems.length; i++) {
                    var item = data.result.queueItems[i];
                    item.displayCreatedDate = moment(item.createdDate).format('lll');
                    item.displayElapsedTime = moment(item.createdDate).fromNow();
                    item.displayDateOfBirth = this.shortDatePipe.transform(item.dateOfBirth);
                }

                this.customerRequestQueueData = data.result;
            }
        );
    };

    public openSearchCustomerModal = (queueItem): void => {
        const searchCriteria = {
            lastName: queueItem.lastName,
            customerIdentificationTypeId: new CustomerIdentificationType().SSN.id,
            customerIdentificationValue: queueItem.ssn,
            dateOfBirth: queueItem.dateOfBirth,
            exactSearch: true
        };

        this.customerSearchService.searchIndividuals(searchCriteria).subscribe(
            data => {
                if (data.results.length != 1 || !data.results[0].customerNumber) {
                    this.showNoMatchingCustomerAlert();
                } else {
                    const completeStatusTypeId = new CustomerRequestStatusType().Complete.id;
                    if (queueItem.customerRequestStatusTypeId != completeStatusTypeId) {
                        queueItem.customerRequestStatusTypeId = completeStatusTypeId;
                        this.changeStatusType(queueItem.customerRequestId, completeStatusTypeId);
                    }

                    const contextData = new CustomerDetailModalContext(data.results[0].customerNumber, true);
                    this.modalService.open(CustomerDetailModalComponent, contextData);
                }
            },
            e => {
                this.showNoMatchingCustomerAlert();
            });
    };

    public openRequestModal = (customerRequestId): void => {
        const data = new CustomerRequestContext(customerRequestId);
        this.modalService.open(CustomerRequestModalComponent, data, ModalSize.Medium);
    };

    private showNoMatchingCustomerAlert = (): void => {
        this.modalService.alert().body('No customer was found matching the provided information.').title('Customer Not Found').okBtn('OK').open();
    };
}
